import { Injectable } from '@angular/core';
import { ElementAttribute } from '@models/editor';
import {
    OrientationPopupConfig,
    OrientationPopupType,
} from '@components/editor/orientation-popup/orientation-popup.component';
import { CanvasService } from './canvas.service';
import { SelectedElementsService } from './selected-elements.service';

@Injectable({
    providedIn: 'root',
})
export class ElementSelectionService {
    constructor(
        private canvasService: CanvasService,
        private selectionService: SelectedElementsService
    ) {}

    buildOrientationPopupConfig(elems: SVGElement[]): OrientationPopupConfig | null {
        if (!elems || elems.length === 0) return null;

        const selected = elems[0] as SVGElement;
        const elementType =
            selected.getAttribute(ElementAttribute.iCreateType) ??
            selected.parentElement?.getAttribute(ElementAttribute.iCreateType);
        const connectorType =
            selected.getAttribute(ElementAttribute.connectorType) ??
            selected.parentElement?.getAttribute(ElementAttribute.connectorType);

        const resolveOwner = (attrName: string): SVGGElement => {
            if (selected.getAttribute(attrName)) {
                return selected as SVGGElement;
            }
            const parent = selected.parentElement as unknown as SVGGElement;
            if (parent?.getAttribute(attrName)) {
                return parent;
            }
            return selected as SVGGElement;
        };

        if (elementType === 'default-valve') {
            return this.buildConfig('valve', resolveOwner(ElementAttribute.iCreateType));
        }
        if (elementType === 'default-pump') {
            return this.buildConfig('pump', resolveOwner(ElementAttribute.iCreateType));
        }
        if (connectorType) {
            return this.buildConfig('connector', resolveOwner(ElementAttribute.connectorType), connectorType);
        }
        return null;
    }

    handleLockedCanvasClick(event: MouseEvent): void {
        const canvas: any = this.canvasService.getCanvas();
        if (event.target) {
            const mouseTarget = canvas.getMouseTarget(event);
            const tagName = mouseTarget?.tagName;
            if (tagName && tagName !== 'svg') {
                this.selectionService.setSelectedElements([mouseTarget]);
                return;
            }
        }
        this.selectionService.setSelectedElements([]);
    }

    private buildConfig(
        type: OrientationPopupType,
        element: SVGGElement | null,
        connectorType?: string
    ): OrientationPopupConfig | null {
        if (!element) return null;
        return { type, element, connectorType };
    }
}
